import { IMerchant, ISuggestion } from "containers/management/management-types";
import { useQuery, QueryConfig } from "react-query";
import { merchantService } from "../services/merchant";

const MERCHANTS = "merchants";
const assortmentCapability = "assortments";

export const useFetchAssortmentMerchants = (options?: QueryConfig<ISuggestion[]>) => {
    return useQuery<ISuggestion[]>(
        MERCHANTS,
        () =>
            merchantService.fetchAssortmentMerchants().then((data: IMerchant[] = []) => {
                return data
                    .reduce((acc: ISuggestion[], item: IMerchant) => {
                        return item.capabilities.some((capability) => capability === assortmentCapability) &&
                            item.capabilities.length === 1
                            ? [
                                  ...acc,
                                  {
                                      label: item.name,
                                      value: item.merchant_id,
                                  },
                              ]
                            : acc;
                    }, [])
                    .sort((itemA, itemB) => {
                        const labelA = itemA.label.toLowerCase();
                        const labelB = itemB.label.toLowerCase();
                        return labelA < labelB ? -1 : labelA > labelB ? 1 : 0;
                    });
            }),
        options
    );
};
